// initial state
import * as base from './base.js'
const baseName = '/admin/api/user_tag'

const obj = base.setBaseUrl('usertag', baseName)
const UserTagnotPagelist = '/admin/api/UserTag/notPagelist'
const contentnotPagelist = '/admin/api/content/notPagelist'
const contentlists = '/admin/api/content/list'
const usertaglists = '/admin/api/user_tag/lists'
const usertagdel = '/admin/api/user_tag/del'




const a = Object.assign(obj,{UserTagnotPagelist,contentnotPagelist,contentlists,usertaglists,usertagdel})
export default a
